import React, { type MouseEvent, useCallback } from 'react';

import navigateActiveTab from '@/utils/navigateActiveTab';

import type { Props } from './types';

const isPlainClick = (event: MouseEvent) =>
  event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;

/**
 * An external link that, in the Chrome extension side panel, opens in the tab
 * beside the panel instead of a new one. Everywhere else, and on modified
 * clicks, it opens a new tab like any other external link.
 */
const ActiveTabLink = ({ href, onClick, ...props }: Props) => {
  const handleClick = useCallback(
    (event: MouseEvent<HTMLAnchorElement>) => {
      onClick?.(event);
      if (event.defaultPrevented || !isPlainClick(event)) return;
      if (navigateActiveTab(href)) event.preventDefault();
    },
    [href, onClick]
  );

  return <a {...props} href={href} onClick={handleClick} rel="noreferrer" target="_blank" />;
};

export default React.memo(ActiveTabLink);
